import { SVGProps } from 'react';

const DepositIcon = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  (<svg
    width={15}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="DepositIcon">
    <path
      d="M1.167 12.667h11.958V8.584h1.167v4.667a.583.583 0 0 1-.584.583H.583A.583.583 0 0 1 0 13.251V8.584h1.167v4.083Z"
      fill="var(--brand-bg-primary)"
    />
    <path
      d="m7.583 6.517 3.541-3.542.825.825-4.95 4.95L2.05 3.8l.826-.825 3.541 3.54V0h1.167v6.517Z"
      fill="var(--brand-bg-primary)"
    />
  </svg>)
);

export default DepositIcon;
